(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('GroupType', GroupType);

    GroupType.$inject = ['$resource'];

    function GroupType ($resource) {
        var resourceUrl =  'api/group-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('GroupTypeSearch', GroupTypeSearch);

    GroupTypeSearch.$inject = ['$resource'];

    function GroupTypeSearch ($resource) {
        var service = $resource('/api/group-types/searchvalue/:searchvalue',{searchvalue:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomGroupTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-group-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
